import { Supervision, SupervisionStatusEnum, Flight, FlightStatusEnum } from 'solar-bo';;
import { ControlEnum } from 'solar-bo';

import { ListBaseComponent } from '@solar/shared/list-base.component';
import { DialogdeleteComponent } from 'basecomponents';
import { AlertType } from 'base-models';
import { MessageError } from 'base-models';
import { SolarService } from '../services/solarservice.service';
import { MatDialogRef } from '@angular/material/dialog';
import { UploadFileData } from 'guploadmgr';

export abstract class FlightBaseComponent extends ListBaseComponent {

  abstract supervision: Supervision;
  protected abstract  solarService:SolarService;

  public constructor() {
    super();
  }

  abstract configsource();

  uiShowActionBtn(resourceId?: string) {
    if (!this.supervision || !this.supervision.info) {
      return false;
    }
    if (this.supervision.info.status == SupervisionStatusEnum.LOCKED
      || this.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
      return false;
    }
    if (resourceId) {
      let permit = this.globService.checkAuthorizationById(resourceId);
      if (!permit) {
        return false;
      }
    }
    return true;
  }

  uiShowButton(resourceId: string, flight: Flight): boolean {

    if (!flight) {
      return false;
    }

    let valid = this.uiShowActionBtn(resourceId);
    if (!valid) {
      return false;
    }

    let st = flight.info.status;
    switch (resourceId) {
      case ControlEnum.BTN_FLIGHT_NEW:
      case ControlEnum.BTN_FLIGHT_UPLOADIMAGES:
      case ControlEnum.BTN_FLIGHT_PROCESS_IMAGES:
      case ControlEnum.BTN_FLIGHT_PROCESS_ISSUES:
      case ControlEnum.BTN_FLIGHT_OPERATOR:
        if (st != FlightStatusEnum.FLIGHT_LOADING_FILES 
          && st != FlightStatusEnum.FLIGHT_FILE_PROCESSING 
          && st != FlightStatusEnum.FLIGHT_ISSUES_PROCESSING 
          ) {
          return true;
        }
    }

    return false;

  }

  openDialogDeleteFlightFiles(model) {
    let dialogRef = this.openDialogDelete("Delete Flight Files", 'Do you want to delete all files for : <b>' + model.name + '</b><div class="alert alert-danger" role="alert">This action can not be undone.</div> ', model);
    dialogRef.componentInstance.mainActionEmitter.subscribe(() => this.deleteFlightFileHandler(model, dialogRef));
  }

  deleteFlightFileHandler(model: UploadFileData, dialogRef: MatDialogRef<DialogdeleteComponent>, ) {
    const dlgComp = dialogRef.componentInstance;
    dlgComp.lockdeletebtn();
    dialogRef.close();
    this.loadinglist = true;
    this.alertmessage = new MessageError(AlertType.Warning, "Deleting Flight files, please wait");
    this.solarService.flightDeleteResourceById(model.id).subscribe(
      () => this.deleteFlightFileSucessHandler(model.id)
      , err => this.handleError(err, "Error deleting Flight files"));
  }

  deleteFlightFileSucessHandler(id: string) {
    /* const index = this.listOriginal.findIndex(el => el.id == id, 0);
    if (index > -1) {
      this.listOriginal.splice(index, 1);
      this.configsource();
    } */
    this.handleSuccesLoad("Flight files deleted");
  }
}
